'use strict';
import {Observable} from 'rxjs/Observable';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {updateLoadingMode} from '../../core-components/loading-icon/utils';
import {logger} from './logger';


DataTagsManageTaggedFilterService.$inject = [
  '$filter',
  'BaseFilterMixin',
  'DataTagsFilterService',
];

export function DataTagsManageTaggedFilterService(
  $filter,
  BaseFilterMixin,
  DataTagsFilterService,
) {
  return function DataTagsManageTaggedFilter(vm, $scope) {
    const baseFilter = new BaseFilterMixin($scope, {
      controllerAs: 'manageDataTags',
      filterTemplate: '',
      defaultSortProperty: 'name',
      filterOptions: {},
      enablePagination: true,
      pageSize: 30,
    });

    return {
      size: baseFilter.size,
      updateLimit: baseFilter.updateRenderLimit,
      initFiltering: initFiltering,
      destroyFiltering: baseFilter.destroyFiltering.bind(baseFilter),
      addSubscription: sub => baseFilter.activeSubscriptions.push(sub),
    };

    function initFiltering(dataTagList, tagLinkList, taggableCollection) {
      baseFilter.registerFilter('filteredList');

      const dataTagList$ = dataTagList
        .$toObservable()
        .map($filter.toArray);

      const tagLinksFilter$ = tagLinkList
        .$toObservable()
        .map(DataTagsFilterService.createTagLinksFilter);

      // TODO: consider adding on child added/removed listeners to remove from in-progress status

      // end to-do

      const filteredList$ = Observable.combineLatest(
        dataTagList$.map(createAppliesToFilter(taggableCollection)),
        baseFilter.sortOptionsObservable,
        tagLinksFilter$,
        baseFilter.filterObservable,
        (dataTagList, sortOptions, tagLinksFilter, autoFilter) => {
          const sortedByOptions = DataTagsFilterService.sortDataTagsOptions(dataTagList, sortOptions);
          const sortedByTagLinks = DataTagsFilterService.sortByTagLinks(sortedByOptions, tagLinksFilter);
          return $filter.$filterWithToString(sortedByTagLinks, autoFilter);
        })
        .catch(epicErrorHandler(logger, 'filteredList$'));

      baseFilter.activeSubscriptions.push(updateLoadingMode(dataTagList$, $scope, vm, true));

      baseFilter.activeSubscriptions.push(filteredList$.subscribe(baseFilter.updateFilter('filteredList', $scope)));

      return {
        getTagLinksFilter$: () => tagLinksFilter$,
      };
    }
  };

  function createAppliesToFilter(collection) {
    return function (dataTagList) {
      const results = [];
      for (let i = 0, length = dataTagList.length; i < length; i++) {
        if (!dataTagList[i].appliesTo || dataTagList[i].appliesTo.indexOf(collection) > -1)
          results.push(dataTagList[i]);
      }
      return results;
    };
  }
}



// WEBPACK FOOTER //
// ./src/js/data-tags/filters/DataTagsManageTaggedFilter.js